import { render, staticRenderFns } from "./BeginCompete.vue?vue&type=template&id=df2ba94a&scoped=true&"
import script from "./BeginCompete.vue?vue&type=script&lang=js&"
export * from "./BeginCompete.vue?vue&type=script&lang=js&"
import style0 from "./BeginCompete.vue?vue&type=style&index=0&id=df2ba94a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2ba94a",
  null
  
)

export default component.exports